import "./Imprint.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OperatorAndContactData from "./sections/OperatorAndContactData";
import BeruflicheAngaben from "./sections/BeruflicheAngaben";
import Haftungshinweis from "./sections/Haftungshinweis";
import Footer from "@/reusable_sections/Footer";
export default function ImprintPage() {
  return <div>
      <Header />
      <Hero />
      <OperatorAndContactData />
      <BeruflicheAngaben />
      <Haftungshinweis />
      <Footer />
    </div>;
}